import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Divider } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import PriceAuditStats from "../../components/price-audit/price-audit-stats";
import PriceAuditFilter from "../../components/price-audit/price-audit-filter";
import PriceAuditTable from "../../components/price-audit/price-audit-table";
import PriceAuditContext from "../../context/price-audit/context";
import PriceAuditContextProvider from "../../context/price-audit/provider";
import AppContext from "../../context/app/context";
import styles from "./styles.module.scss";

const PriceAuditPageContent = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { actions, query, loading } = useContext(PriceAuditContext);

  // Fetch data when query or direction changes
  useEffect(() => {
    actions.getStatistics();
    actions.getLogs();
  }, [query, direction]);

  return (
    <div className={styles.container}>
      <PageHeader
        title={t("price_audit")}
        extra={
          <Button
            type="primary"
            icon={<ExportOutlined />}
            loading={loading.includes("export")}
            onClick={() => actions.exportExcel()}
          >
            {t("export_excel")}
          </Button>
        }
      />

      <PriceAuditStats />

      <Divider />

      <PriceAuditFilter />

      <PriceAuditTable />
    </div>
  );
};

const PriceAuditPage = () => {
  return (
    <PriceAuditContextProvider>
      <PriceAuditPageContent />
    </PriceAuditContextProvider>
  );
};

export default PriceAuditPage;
